import React, { useContext, useState } from "react"

import useLog from "../hooks/useLog"


/**
 * beware before changing this is parsed in translateErrorMessage.js
 */
export class ContextError extends Error {
    constructor(contextmess, error) {
        super(error);
        this.name = "ContextError";
        this.context = contextmess
        this.error = error
    }
    toString() {
        return this.name + ": " + this.context + ": " + this.error.toString()
    }
}


const GlobalErrorContext = React.createContext(null)


export const GlobalErrorContextProvider = (props) => {

    const function_id = "GlobalErrorContext(): "
    const classname = function_id
    const log = useLog(function_id)

    const [globalError, set_globalError] = useState(null)
    const [needAutoReload, set_needAutoReload] = useState(false)

    const state = {
        globalError: globalError,
        needAutoReload: needAutoReload,

        throwContextError: throwContextError,
        resetGlobalError: resetGlobalError,

        set_needAutoReload: set_needAutoReload,
    }

    function resetGlobalError() {
        set_globalError(null)
    }


    function _should_hide_error_and_reload(message) {
        if (message.includes("Error: Cannot read location")) return true

        // TODO this is a hack, we might want to handle those RUN errors more properly but for now it's best to hide them
        if (message.includes("not found in the transaction txid")) return true

        return false
    }

    /**
     * known limitation: WhatsOnChain doesn't support spends (tokkenr node handles it instead).
     * this error is a permanent API limitation, not a transient failure, so reloading never fixes it.
     * it can be thrown from many different sync({ inner: true }) call sites, so we just hide it
     * everywhere without triggering an auto-reload (which would otherwise loop forever).
     */
    function _should_hide_error_only(message) {
        if (message.includes("WhatsOnChain API does not support spends")) return true

        return false
    }

    /**
     * will throw a ContextError
     * 
     * @param {*} error 
     * @param {string} premess 
     */
    function throwContextError(error, premess = "") {
        // BEWARE DO NOT RETURN IN THIS FUNCTION, IT MUST ABSOLUTELY THROW AN ERROR !!!
        // because a lot of others functions depend on this behavior

        if (premess.length > 0) {
            if (!premess.slice(premess.length - 3, premess.length).includes(':')) {
                premess += " : "
            }
            premess += "\n"
        }

        var mess = "CONTEXT ERROR: \n"
            + "premess = " + premess + "\n"
            + "error   = " + error

        props.console.error(mess, error)  // this is necessary to display the stackTrace in logs

        if (mess.includes('Invalid owner: ""')) {
            props.console.warn("detected empty owner, redirecting to home")
            // redirect to '/' so user can reload his wallet manually
            window.location.href = '/';
            return
        }

        if (_should_hide_error_only(premess + error)) {
            return
        }

        if (_should_hide_error_and_reload(premess + error)) {
            set_needAutoReload(true)
            return
        }

        set_globalError(mess)

        // throw for callers to catch it
        throw new ContextError(premess, error)
    }


    return (
        <GlobalErrorContext.Provider value={state}>
            {props.children}
        </GlobalErrorContext.Provider>
    )

}

export default GlobalErrorContext
